import styled from 'styled-components'

export const Wrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 100%;
width: 100%;
`

export const CardContent = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
height:${(props) => (props.isMobile ? '90%' : '80%')};
width:${(props) => (props.isMobile ? '95%' : '670px')};
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--general-font-family);
color: var(--font-color-blue002e5c);
background-color: #fff;
border-radius: 10px;
div{
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
}

p{
text-align: center;
font-size: var(--general-large-body-font-size);
font-weight: var(--general-large-body-font-weight);
line-height: 26.348px;
width: 83%;
}
`

export const Title = styled.h1`
font-size: ${(props) => (props.isMobile ? 'var(--general-page-header-font-size)' : 'var(--payment-result-page-header-font-size)')};
font-weight: var(--font-weight-semi-bold);
padding-bottom: 22px;
padding-top: ${(props) => (props.isMobile ? '20px' : '45px')};
`

export const ThanksMsg = styled.div`
font-size: var(--general-header-font-size);
font-weight: var(--general-header-font-weight);
line-height: 26.348px;
width: 83%;
text-align: center;
margin-top: 20px;
`

export const ButtonWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
font-size: var(--general-button-font-size);
font-weight: var(--general-button-font-weight);
margin-top: 40px;
gap: 14px;
width: 100%;
`

export const CalendarLabel = styled.div`
font-size: var(--general-label-font-size);
font-weight: var(--general-label-font-weight);
color: var(--font-color-blue002e5c);
text-align: center;
`

export const CalendarIconsRow = styled.div`
display: flex;
flex-direction: row !important;
justify-content: center;
align-items: flex-start;
gap: 28px;
flex-wrap: wrap;
width: 83%;
margin-bottom: 10px;
`

export const CalendarIconButton = styled.button`
display: flex;
flex-direction: column;
align-items: center;
gap: 12px;
background: none;
border: none;
cursor: pointer;
padding: 0;
span {
    font-size: var(--general-button-font-size);
    font-weight: var(--general-button-font-weight);
    color: var(--font-color-blue002e5c);
    text-align: center;
    max-width: 72px;
    line-height: 1.3;
}
&:hover svg {
    opacity: 0.8;
}
`

export const ShareButton = styled.button`
display: flex;
min-width: 185px;
padding: 8px 20px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 5px;
background: rgba(37, 85, 239, 1);
color: var(--font-color-white);
border: 0;
height: 48px;
font-size: var(--general-button-font-size);
font-weight: var(--general-button-font-weight);
cursor: pointer;
`

export const CalendarButton = styled.button`
display: flex;
min-width: 185px;
padding: 8px 20px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 5px;
background: rgba(37, 85, 239, 1);
color: var(--font-color-white);
border: 0;
height: 48px;
font-size: var(--general-button-font-size);
font-weight: var(--general-button-font-weight);
cursor: pointer;
`

export const DoneButton = styled.button`
color: var(--font-color-blue007bff);
line-height: 32px;
background-color: transparent;
border: 0;
min-width: 185px;
height: 48px;
font-size: var(--general-button-font-size);
font-weight: var(--general-button-font-weight);
cursor: pointer;
`
